module.exports = __webpack_public_path__ + "static/key-visual-5cd0f7d6b9217b65310acff22df6b6cf.jpg";